import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import { MenuItem, Grid, TextField, Typography, Button, useTheme } from '@material-ui/core';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FormInput from "../../../../../FormInput";
import { pathOr } from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles, { getMuiTheme } from "./styles";
import { useDispatch, useSelector } from "react-redux";

import Collapse from '@mui/material/Collapse';

import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { getCalculatedData } from "../../../../../../store/actions/dashboard.actions";
import { toast } from "react-toastify";
import { validateForm } from '../../../../../../common/utils';
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../Skeleton/index";


const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function CustomDashletForm({ data, allTabFilter, currentUserAttributes }) {
  const dispatch = useDispatch();
  const { userPreference, config } = useSelector((state) => state.config);
  const calendar_format = pathOr(config.default_date_format, ['attributes', 'global', 'calendar_format'], userPreference);
  const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_format'], userPreference);
  const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'time_reg_format'], userPreference);
  const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_positions'], userPreference);
  const [errors, setErrors] = useState({});
  const [expanded, setExpanded] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = useState([]);
  const [outPut, setOutput] = useState(null);
  const classes = useStyles();
  const theme = useTheme();
  const [fields, setFields] = useState(pathOr([], ['data'], data));
  const sameResponseTo = pathOr([], ['sameResponseTo', 'data'], data);
  useEffect(() => {
    const initialState = [];
    const fields2 = fields;
    Object.values(fields).map((row, rowNum) => {
      // console.log("sameResponseTo",sameResponseTo,row)

      initialState[row['name']] = pathOr(pathOr('', ['value'], row), ['0', pathOr('', ['autoValue', 2], row)], sameResponseTo);
      fields2[rowNum]['value'] = pathOr(pathOr('', ['value'], row), ['0', pathOr('', ['autoValue', 2], row)], sameResponseTo);
    })
    setFields(fields2);
    setFormData(initialState);
    // console.log(fields2,initialState,sameResponseTo,data)
  }, [data])
  const dataisRightValue = pathOr('', ['isRightValue'], data);
  const isFieldLabel = pathOr([], ['isFieldLabel'], data);
  const isRightValue = fields.find((element) => {
    return element.name === dataisRightValue;
  });
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const buildQueryString = (items, sameResponseTo) => {
    let filterQuery = "?";
    let filterFields = {};

    for (let key in items) {
      let isIntField = fields.some(element => element.name === key && (element.type === 'int' || element.type === 'decimal'));
      // let client_id = items[key][0] === '$current_user->id' ? pathOr('', ['id'], currentUserAttributes) : items[key];

      // filterQuery =
      // filterQuery + `${key}=`+pathOr(pathOr(pathOr(client_id,[items[key][1],items[key][2]],allTabFilter),[items[key][1],items[key][2]],sameResponseTo),[items[key][1]],formData)+`&`;
      // let actValue = pathOr(pathOr(pathOr(client_id, [items[key][1], items[key][2]], allTabFilter), [items[key][1], items[key][2]], sameResponseTo), [items[key][1]], formData);
      let actValue = '';
      switch (items[key][0]) {
        case 'allTabFilter':
          actValue = pathOr('', [items[key][1], items[key][2]], allTabFilter);
          break;
        case 'sameResponseTo':
          actValue = pathOr('', [items[key][1], items[key][2]], sameResponseTo);
          break;
        case 'formData':
          actValue = pathOr('', [items[key][1]], formData);
          break;
        case '$current_user->id':
          actValue = pathOr('', ['id'], currentUserAttributes);
          break;
        case 'default':
          actValue = '';
          break;
      }
      filterFields[key] = isIntField ? parseInt(actValue) : actValue;
    }
    return filterFields;
  }



  const isSubmitFilter = (sameResponseTo) => {
    let validate = validateForm(fields, formData, { calendar_format, date_reg_format, time_reg_format, date_reg_positions, view: 'createview' });
    // return;
    setErrors(validate.errors);
    // return;
    if (validate.formIsValid) {
      setLoading(true);
      const query_string = buildQueryString(pathOr([], ['request'], data), sameResponseTo);
      try {
        dispatch(getCalculatedData(query_string)).then(function (res) {
          if (res) {
            setOutput(res)
            setLoading(false);
          } else {
            toast('Something went wrong!');
            setLoading(false);

          }
        });
      } catch (e) {
        toast('Something went wrong!');

      }

    }
  }
  const onChange = (field, val, data) => {
    setOutput(null);
    setFormData({ ...formData, [field['name']]: val })


  };

  const handleCheck = (hideShowData, val) => {
    return !hideShowData.some(item => val === item);
  }
  const showFields = (fields) => {
    return fields.map((field, fieldNum) =>


      handleCheck(pathOr([], ['hideShow', 'value'], field), pathOr(false, [pathOr(false, ['hideShow', 'field'], field)], formData)) ? <Grid key={fieldNum} item xs={pathOr(12, ['grid', 'xs'], field)} sm={pathOr(12, ['grid', 'sm'], field)}><div key={fieldNum} className={classes.filterFieldBox}>
        {isFieldLabel ? <Typography className={classes.axaLabel} >
          {field.label}
        </Typography> : null}

        <FormInput
          field={{ ...field, ['label']: '' }}
          //  field={{...field,['label']:'',['class']:classes.axaField}}
          //  initialValues={initialValues}
          value={field.type==='decimal'?getCalculations('getValueOnlyInDecimal', field.value):field.value || ''}
          //  dynamicEnumValue={initialValues[field.parentenum] || ""}
          module={field.module}
          small={true}
          errors={errors}
          onChange={(val) => onChange(field, val, data)}
        />
      </div></Grid> : null
    )
  }
  return (
    <div className={classes.filterBox}>   <MuiThemeProvider theme={getMuiTheme(theme)}> <Grid
      container
      direction="row"
      // justifyContent="space-between"
      alignItems="center"
    >
      {data.isHeader || data.isSubHeader ?
        <Grid item xs={7}>
          <Typography variant='h5' >
            {data.label}
          </Typography>
        </Grid> : null}
      <Grid item xs={4} style={{ textAlign: 'right' }}>
        <span className={classes.axaLabel} >{pathOr(null, ['isRightText'], data)}</span>
        {dataisRightValue && pathOr(null, ['value'], isRightValue)}
      </Grid>
      <Grid item xs={1} style={{ textAlign: 'right' }}>
        {data.isExpandIcon ? <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <FilterAltIcon color={!expanded ? "primary" : "disabled"} />
        </ExpandMore> : null}
      </Grid>

    </Grid>
      {data.isExpandIcon ?
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Grid
            container
            direction="row"
            // justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >  {showFields(fields)}
          </Grid>
          {data.isSubmit ? <Button variant="contained" size="small" color="primary" onClick={() => isSubmitFilter(sameResponseTo)} fullWidth={true}>{data.submitText}</Button> : null}
        </Collapse> : <Grid
          container
          direction="row"
          // justifyContent="space-between"
          alignItems="center"
          spacing={1}
        > {showFields(fields)}</Grid>}
      {!data.isExpandIcon && data.isSubmit ? <Button variant="contained" size="small" color="primary" onClick={() => isSubmitFilter(sameResponseTo)} fullWidth={true}>{data.submitText}</Button> : null}

      {loading ? <SkeletonShell layout="calculator" /> : outPut ?
        <div>
          <br />
          {formData['type'] === 'Future' ? <Typography  >The Policy {pathOr('0', ['0', 'pname'], sameResponseTo)} will reach Future value <strong>{pathOr('USD', [0, 'currency'], allTabFilter)} {getCalculations('getValueOnlyInDecimal', outPut)}</strong> , on {formData['transactionType'] || ''} of {getCalculations('getValueOnlyInDecimal', formData['amount']) || ''}  {pathOr('USD', [0, 'currency'], allTabFilter)} per annum for {formData['year'] || ''} {formData['year'] > 1 ? 'years' : 'year'}.

          </Typography> : formData['type'] === 'topup_withdraw' ?

            <Typography  >The Policy {pathOr('0', ['0', 'pname'], sameResponseTo)} will reach Future value {pathOr('USD', [0, 'currency'], allTabFilter)} {getCalculations('getValueOnlyInDecimal', formData['amount']) || ''}, on {outPut > pathOr('0', ['0', 'AV'], sameResponseTo) ? 'Top Up' : 'Withdrawl'} of <strong>{pathOr('USD', [0, 'currency'], allTabFilter)} {getCalculations('getValueOnlyInDecimal', outPut)} </strong> per annum for {formData['year'] || ''} {formData['year'] > 1 ? 'years' : 'year'}.

            </Typography> : pathOr('', ['meta', 'message'], outPut) ? <Typography>{pathOr('', ['meta', 'message'], outPut)}</Typography> : Object.keys(pathOr({}, ['data'], outPut)).map((fieldKey) => <Typography key={fieldKey}><strong>{fieldKey}: </strong>{getCalculations('getValueOnlyInDecimal', pathOr('', ['data', fieldKey], outPut))}</Typography>)}
        </div> : null}
    </MuiThemeProvider>
    </div>
  )
}